import React, { createContext, useContext } from 'react';

const AgentHubContext = createContext();

export const AgentHubProvider = ({ children, value }) => {
  return (
    <AgentHubContext.Provider value={value}>
      {children}
    </AgentHubContext.Provider>
  );
};

export const useAgentHubContext = () => {
  const context = useContext(AgentHubContext);
  // Retornar null se não estiver dentro do provider (modo standalone)
  return context || null;
};

export default AgentHubContext;